import { useState, useEffect } from 'react';

export interface ProjectDocument {
  id: string;
  name: string;
  type: string;
  folder: string;
  uploader: {
    name: string;
    avatar: string;
  };
  updatedAt: string;
  size: string;
  extension: string;
}

export function useProjectDocs() {
  const [docs, setDocs] = useState<ProjectDocument[]>([]);
  const [folders, setFolders] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFolders([
        { id: '1', name: '01. Hồ sơ pháp lý', count: 8 },
        { id: '2', name: '02. Hồ sơ thiết kế', count: 12 },
        { id: '3', name: '03. Hồ sơ thi công', count: 24 },
        { id: '4', name: '04. Biên bản & Nghiệm thu', count: 18 },
        { id: '5', name: '05. Báo cáo', count: 15 },
        { id: '6', name: '06. Ảnh hiện trường', count: 326 },
        { id: '7', name: '07. Tài liệu khác', count: 6 },
      ]);

      setDocs([
        {
          id: '1',
          name: 'Quyết định phê duyệt dự án.pdf',
          type: 'Pháp lý',
          folder: '01. Hồ sơ pháp lý',
          uploader: { name: 'Nguyễn Văn An', avatar: 'https://i.pravatar.cc/150?u=4' },
          updatedAt: '15/05/2024 09:30',
          size: '1.2 MB',
          extension: 'pdf'
        },
        {
          id: '2',
          name: 'Hợp đồng thi công số 01/2024.docx',
          type: 'Pháp lý',
          folder: '01. Hồ sơ pháp lý',
          uploader: { name: 'Nguyễn Văn An', avatar: 'https://i.pravatar.cc/150?u=4' },
          updatedAt: '15/05/2024 09:28',
          size: '2.4 MB',
          extension: 'docx'
        },
        {
          id: '3',
          name: 'Bản vẽ tổng mặt bằng.pdf',
          type: 'Thiết kế',
          folder: '02. Hồ sơ thiết kế',
          uploader: { name: 'Lê Hoàng Nam', avatar: 'https://i.pravatar.cc/150?u=2' },
          updatedAt: '14/05/2024 16:20',
          size: '4.8 MB',
          extension: 'pdf'
        },
        {
          id: '4',
          name: 'Bản vẽ chi tiết cây xanh.dwg',
          type: 'Thiết kế',
          folder: '02. Hồ sơ thiết kế',
          uploader: { name: 'Phạm Văn Tài', avatar: 'https://i.pravatar.cc/150?u=3' },
          updatedAt: '14/05/2024 16:18',
          size: '8.6 MB',
          extension: 'dwg'
        },
        {
          id: '5',
          name: 'Bảng thống kê khối lượng.xlsx',
          type: 'Thi công',
          folder: '03. Hồ sơ thi công',
          uploader: { name: 'Trần Minh Tuấn', avatar: 'https://i.pravatar.cc/150?u=1' },
          updatedAt: '12/05/2024 11:05',
          size: '1.1 MB',
          extension: 'xlsx'
        },
      ]);
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return { docs, folders, isLoading };
}
